interface ControlOptionProps {
  label: string;
  description: string;
  control: React.ReactNode;
}

export const ControlOption = ({ label, description, control }: ControlOptionProps) => {
  return (
    <div className="flex flex-row gap-x-4 items-center justify-between border border-gray-300 bg-gray-100 rounded-md p-4">
      <div className="flex flex-col gap-y-2">
        <div className="font-semibold">{label}</div>
        <div className="text-sm text-gray-600">
          {description}
        </div>
      </div>
      <div className="flex flex-row gap-x-4 items-center">
        {control}
      </div>
    </div>
  );
};